import React from 'react';
import Hero from '../components/Hero';
import StoryHook from '../components/StoryHook';
import TheTruths from '../components/TheTruths';
import PurchaseSection from '../components/PurchaseSection';
import TestimonialsStrip from '../components/TestimonialsStrip';
import AuthorStrip from '../components/AuthorStrip';
import FaqStrip from '../components/FaqStrip';

const HomePage = () => (
  <>
    <Hero />
    <StoryHook />
    <TheTruths />
    <TestimonialsStrip />
    <AuthorStrip />
    <FaqStrip />
    <PurchaseSection />
  </>
);

export default HomePage;